/* ===================================================================
   CONSCIENCE — Kalpa Druma
   Shared behaviour. Every init is idempotent and re-runs on
   shopify:section:load so the theme editor stays live.
   =================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  var CN = window.ConscienceUI || {};
  CN.current = CN.current || null;

  /* ---------------- choosing a dye ---------------- */
  CN.select = function (key) {
    var chip = document.querySelector('.cn-chip[data-key="' + key + '"]');
    if (!chip) return;

    var d = {
      key: key,
      name: chip.dataset.name,
      hex: chip.dataset.hex,
      light: chip.dataset.light === 'true',
      eyebrow: chip.dataset.eyebrow,
      p1: chip.dataset.p1,
      p2: chip.dataset.p2,
      spec: chip.dataset.spec
    };
    CN.current = d;

    root.style.setProperty('--cn-accent', d.hex);

    document.querySelectorAll('.cn-chip').forEach(function (c) {
      c.setAttribute('aria-pressed', String(c.dataset.key === key));
    });

    document.querySelectorAll('[data-feature]').forEach(function (feature) {
      var body = feature.querySelector('[data-feature-body]');
      var swatch = feature.querySelector('[data-feature-swatch]');
      var name = feature.querySelector('[data-feature-name]');
      var hex = feature.querySelector('[data-feature-hex]');

      if (body) {
        body.classList.add('is-fading');
        setTimeout(function () {
          set(feature, '[data-feature-eyebrow]', d.eyebrow);
          set(feature, '[data-feature-p1]', d.p1);
          set(feature, '[data-feature-p2]', d.p2);
          set(feature, '[data-feature-spec]', d.spec);
          body.classList.remove('is-fading');
        }, REDUCED ? 0 : 320);
      }
      if (swatch) swatch.style.background = d.hex;
      if (name) {
        name.textContent = d.name;
        name.style.color = d.light ? 'var(--cn-ink)' : 'var(--cn-ground)';
      }
      if (hex) {
        hex.textContent = (d.hex || '').toUpperCase();
        hex.style.color = d.light ? 'var(--cn-ink)' : 'var(--cn-ground)';
      }
    });

    document.querySelectorAll('[data-stone-wrap]').forEach(resetStone);
  };

  function set(scope, sel, value) {
    var el = scope.querySelector(sel);
    if (el) el.textContent = value || '';
  }

  window.ConscienceUI = CN;

  /* ---------------- the pounding stone ---------------- */
  var STATES = [
    'Press the stone',
    'The petals give a little',
    'Colour begins to gather',
    'The pigment deepens',
    'Almost drawn out',
    'Colour drawn. The yarn is dyed.'
  ];

  function resetStone(wrap) {
    var hex = CN.current ? CN.current.hex : '#DE9C77';
    wrap.dataset.pounds = '0';
    var pigment = wrap.querySelector('[data-pigment]');
    var petals = wrap.querySelector('[data-petals]');
    if (pigment) { pigment.setAttribute('fill', hex); pigment.style.opacity = 0; }
    if (petals) { petals.setAttribute('fill', hex); petals.style.opacity = 0.85; }
    set(wrap, '[data-stone-count]', 'Pounding 0');
    set(wrap, '[data-stone-state]', STATES[0]);
    wrap.querySelectorAll('.cn-yarn-line').forEach(function (y) {
      y.setAttribute('stroke', 'var(--cn-undyed)');
    });
  }

  function initStone(scope) {
    scope.querySelectorAll('[data-stone-wrap]').forEach(function (wrap) {
      if (wrap.dataset.ready === 'true') return;
      wrap.dataset.ready = 'true';

      var btn = wrap.querySelector('[data-stone]');
      var max = parseInt(wrap.dataset.max || '5', 10);
      resetStone(wrap);

      if (!btn) return;
      btn.addEventListener('click', function () {
        var n = parseInt(wrap.dataset.pounds || '0', 10);
        if (n >= max) { resetStone(wrap); return; }
        n++;
        wrap.dataset.pounds = String(n);
        var t = n / max;
        var hex = CN.current ? CN.current.hex : '#DE9C77';

        btn.classList.add('is-pounding');
        setTimeout(function () { btn.classList.remove('is-pounding'); }, 170);

        var pigment = wrap.querySelector('[data-pigment]');
        var petals = wrap.querySelector('[data-petals]');
        if (pigment) pigment.style.opacity = t;
        if (petals) petals.style.opacity = Math.max(0, 0.85 - t * 0.95);

        var yarns = wrap.querySelectorAll('.cn-yarn-line');
        yarns.forEach(function (y, i) {
          if (i < Math.round(t * yarns.length)) y.setAttribute('stroke', hex);
        });

        if (n >= max) {
          set(wrap, '[data-stone-count]', 'Extract ready');
          set(wrap, '[data-stone-state]', STATES[max]);
        } else {
          set(wrap, '[data-stone-count]', 'Pounding ' + n);
          set(wrap, '[data-stone-state]', STATES[Math.min(n, STATES.length - 1)]);
        }
      });
    });
  }

  /* ---------------- chips and palette ---------------- */
  function initChips(scope) {
    scope.querySelectorAll('.cn-chip').forEach(function (chip) {
      if (chip.dataset.ready === 'true') return;
      chip.dataset.ready = 'true';
      chip.addEventListener('click', function () { CN.select(chip.dataset.key); });
    });

    scope.querySelectorAll('.cn-swatch[data-key]').forEach(function (sw) {
      if (sw.dataset.ready === 'true') return;
      sw.dataset.ready = 'true';
      sw.addEventListener('click', function () {
        CN.select(sw.dataset.key);
        var target = document.querySelector('[data-dye-studio]');
        if (target) target.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  /* ---------------- tabs ---------------- */
  function initTabs(scope) {
    scope.querySelectorAll('[data-tabs]').forEach(function (group) {
      if (group.dataset.ready === 'true') return;
      group.dataset.ready = 'true';
      var tabs = group.querySelectorAll('.cn-tab');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) { x.setAttribute('aria-selected', 'false'); });
          t.setAttribute('aria-selected', 'true');
          group.querySelectorAll('.cn-panel').forEach(function (p) {
            p.setAttribute('data-open', String(p.id === t.dataset.panel));
          });
        });
      });
    });
  }

  /* ---------------- ingredients ---------------- */
  function runIngredients(list) {
    if (REDUCED || list.dataset.running === 'true') return;
    list.dataset.running = 'true';
    var items = list.querySelectorAll('.cn-ingredient');
    var i = 0;
    setInterval(function () {
      items.forEach(function (el) { el.classList.remove('is-lit'); });
      items[i % items.length].classList.add('is-lit');
      i++;
    }, 900);
  }

  /* ---------------- reveal ---------------- */
  function initReveal(scope) {
    var rises = scope.querySelectorAll('.cn-rise:not(.is-seen)');
    if (!('IntersectionObserver' in window) || REDUCED) {
      rises.forEach(function (el) {
        el.classList.add('is-seen');
        if (el.hasAttribute('data-ingredients')) runIngredients(el);
      });
      return;
    }
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-seen');
        if (e.target.hasAttribute('data-ingredients')) runIngredients(e.target);
        ro.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    rises.forEach(function (el) { ro.observe(el); });
  }

  /* ---------------- boot ---------------- */
  function init(scope) {
    scope = scope || document;
    initChips(scope);
    initStone(scope);
    initTabs(scope);
    initReveal(scope);

    if (!CN.current) {
      var first = document.querySelector('.cn-chip');
      if (first) CN.select(first.dataset.key);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { init(e.target); });
})();
